var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jump"},[_c('p',{staticStyle:{}},[_vm._v(" 正在跳转到支付页面，请稍候~ ")]),_c('img',{attrs:{"src":require("@/assets/images/loading.gif"),"alt":""}})])
}]

export { render, staticRenderFns }